import axios from "axios";
import { PAYMENT_URL } from "../constant/server";
import axiosInstance from "./api_instance";

export const createOrder = ({ eventId, items }) => {
  return axiosInstance.post(`client/orders`, { eventId, items });
};

export const checkoutOrder = ({ eventId, items }) => {
  return axiosInstance.post(`client/orders`, { eventId, items });
};

export const getOrderDetail = (orderId) => {
  return axiosInstance.get(`client/orders/${orderId}`);
};

export const getOldOrder = (orderId) => {
  return axiosInstance.get(`client/events/${orderId}/check-order`);
};

export const cancelOrder = (orderId) => {
  return axiosInstance.post(`client/orders/${orderId}/cancel`);
};

export const downloadPDF = (orderId, language) => {
  return axiosInstance.post(`client/tickets/download-pdf`, {
    orderId,
    language,
  });
};

export const checkOrderStatus = (transactionId) => {
  return axiosInstance.post(
    `${PAYMENT_URL}/client/api/v1/payment/transactions/${transactionId}/check-status`,
    {},
    {
      headers: {
        "x-token-auth": process.env.NEXT_PUBLIC_X_AUTH_TOKEN,
      },
    }
  );
};

export const getCouponDetail = (ticketTypeId, couponCode) => {
  return axiosInstance.post(
    `client/ticketTypes/${ticketTypeId}/coupons/apply/${couponCode}`
  );
};
